export const EXTRA_DISPLAY_LIMIT = 4;
